import React, { use, useEffect, useState } from "react";
import SearchFilter from "../../components/search-filter";
// import config from "../../config";
import client from "../../clients";
import NoAptImg from  '../../assets/no-appt.svg';
import { formatDateTime, getUserRole, isCurrentTimeGreaterThan, startLoader, stopLoader } from "../../lib/utils";
import { getAllAppointment, getAllAppointmentSlots, saveAppointMent } from "../appointment/helper/api";
import { isAuthenticated } from "../../auth";
import FlatPicker from 'flatpickr';
import { getMember } from "../member/helper/api";
import Toast from "../../lib/toast";
import { getAllParameters } from "../parameters/helper/api";

let flatpickr;

const MemberSlotBooking = (props) => {

  const [selectedDate,setSelectedDate] = useState('');
  const [appointments,setAppointments] = useState([]);
  const [selectedUserApt, setSelectedUserApt] = useState("");
  const [userSearchKey,setUserSearchKey]=useState('');
  const {user, token} = isAuthenticated();
  const [selectedDateFilter, setSelectedDateFilter] = useState("");
  const [isUserListOpen, setUserListOpen] = useState(false);
  const [userRoleTypes, setUserRoleTypes] = useState(["Rehab Specialist", "Wellness Coach", "Dietitian", "Personal Trainer", "Pilates Instructor"])
  const [appointmentslots,setAppointmentSlots] = useState([]);
  const [Member,setMember] = useState('');
  const currentDate = new Date();
  const [filterByDate,setFilterByDate] = useState({
    start:new Date(currentDate),
    end:new Date(currentDate.setDate(currentDate.getDate() + 7))
  });
  const [dateStrings,setDateStrings] = useState([]);
  const [selectedSlot,setSelectedSlot] = useState('');
  const [isButtonLock,setButtonLock] = useState(true);
  const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
  const [currentElementId, setCurrentElementId] = useState("");
  const [parameters,setParameters] = useState([]);
  const [selectedSessionType, setSelectedSessionType] = useState("appointment");
  const [groupClassTypes, setGroupClassTypes] = useState([]);
  const [selectedGroupClass, setSelectedGroupClass] = useState([]);
  const [isGroupClassDropdownOpen, setGroupClassDropdownOpen] = useState(false);
  const [groupClasses, setGroupClasses] = useState([]);
  const [isDateRangeEnabled, setDateRangeEnabled] = useState(false);
  const [dateRange, setDateRange] = useState("");


  const selectAppointmentType = (type) => {
    setSelectedAppointmentType(type)
  }


    const GetAllParameters = async () =>{
      try{
        const params = {
          type:"appointmentType",
          noLimit:"noLimit"
        }
        const response = await getAllParameters(user._id,token,params);

        console.log(response)
        if(!response.error){
          setParameters(response);
        }
      }catch(error){
  
      }
    }

  const bookAppointment = async event =>{
    try{
      await startLoader()
      setButtonLock(true)
      const payload = {
        type:selectedAppointmentType,
        weekDayName:selectedSlot.dayName,
        appointmentSlotId:selectedUserApt._id,
        slotRange:selectedSlot.slotRange,
        startTime:selectedSlot.slotTime.startTime,
        endTime:selectedSlot.slotTime.endTime,
        assigedUser:selectedUserApt.userId,
        branchId:Member.branchId,
        gymId:Member.gymId,
        memberId:Member._id,
        appointmentDate:selectedSlot.date,
        appointmentDateString:selectedSlot.dateString
      };
       
      const response = await saveAppointMent(user._id,token,payload);
      if(!response.error){
        new Toast({
          type:"success",
          message:"Appointment saved successfully",
          duration:3000
        })
        props.handleApiAction();
        props.handleCloseModal();

      }else{
        new Toast({
          type:"warning",
          message:response.error,
          duration:3000
        })
      }
      await stopLoader()
    }catch(error){
      await stopLoader()
    }
    setButtonLock(false)
  }


  const handleSelectSlot = slot =>{
    setSelectedSlot(slot);
  }


  const handleSelectDate = event => {
    flatpickr = FlatPicker("#date-select", {
      disableMobile: true,
      onChange: (e) => {
        if(e.length>0) {
          setSelectedDate(e[0]);
        }
      }
    })
    flatpickr.open();
  }


    

  const handleSearchingData = (searchData) => {
    setUserSearchKey(searchData)
  }

  const toggleUserList = () => {
    setUserListOpen(!isUserListOpen)
  }

  const handleSelectUser = (user) => {
    setSelectedUserApt(user)
    toggleUserList();
  }
  

   const getAppointmentSlotLimitAndDuration = (appointment = null) =>{
      let result = {
        slot_limit:1,
        slot_duration:15
      };
  
      if(appointment){
        const booking = appointment.bookingDetail;
        const slotRange = booking.slotRange;
        if(selectedUserApt.weekdays[client.config.weekDayDisplayNames[client.config.weekDays[new Date(booking.appointmentDate).getDay()]].toLowerCase().subsstring(0,3)]){
          result.slot_duration = selectedUserApt.weekdays[client.config.weekDayDisplayNames[client.config.weekDays[new Date(booking.appointmentDate).getDay()]].toLowerCase().subsstring(0,3)].slot_duration;
          const slot = selectedUserApt.weekdays[client.config.weekDayDisplayNames[client.config.weekDays[new Date(booking.appointmentDate).getDay()]].toLowerCase().subsstring(0,3)].slots.find(d=>d.slotRange.startTime.hr == slotRange.startTime.hr && d.slotRange.startTime.min == slotRange.startTime.min && d.slotTime.startTime.period == slotRange.startTime.period && d.slotRange.endTime.hr == slotRange.endTime.hr && d.slotRange.endTime.min == slotRange.endTime.min && d.slotRange.endTime.period == slotRange.endTime.period)
          if(slot && slot.availableSlots && slot.availableSlots.length){
            const avlslot = slot.availableSlots.find(d=>booking.slotTime.startTime.hr == d.startTime.hr && booking.slotTime.startTime.min == d.startTime.min && booking.slotTime.startTime.period == d.startTime.period && booking.slotTime.endTime.hr == d.endTime.hr &&  booking.slotTime.endTime.min == d.endTime.min &&booking.slotTime.endTime.period == d.endTime.period )
            if(avlslot && avlslot.slot_limit != null){
              result.slot_limit = avlslot.slot_limit;
            }
          }
        }
      }
  
      return result;
    }


  const GetColor = (appointment) =>{
    let statusColor; 
    let memberIDs = [];
    if(appointment.memberIDs) memberIDs = [...appointment.memberIDs];
    if(appointment.memberId && memberIDs.indexOf(appointment.memberId) == -1) memberIDs.push(appointment.memberId);


    let  res_slotlimit_duration = {
      slot_limit:1,
      slot_duration:15
    }
    
    try{
        res_slotlimit_duration = getAppointmentSlotLimitAndDuration(appointment);
    }catch(error){

    }


    if(appointment.status == "pending" && memberIDs.length> res_slotlimit_duration.slot_limit) statusColor = "#9F201C";
    else if(appointment.status == "pending") statusColor="#DE931E";
    else if(appointment.status == "completed")statusColor="#5D883C";
    else if(appointment.status == "pending" && isCurrentTimeGreaterThan(`${appointment.bookingDetail.slotTime.endTime.hr}:${appointment.bookingDetail.slotTime.endTime.hr} ${appointment.bookingDetail.slotTime.endTime.period}`)) statusColor="#FFB800";
    // else if(appointment.status == "cancelled") statusColor = "#F15D22";
    else if(appointment.status == "blocked") statusColor = "#7E7E7E";
    else statusColor = "#0088DA";
    return statusColor;
  }

  const GetAppointments = async () =>{

    try{
      let dateFrom = new Date(filterByDate.start);
      dateFrom.setHours(0,0,0,0);
      let dateTo =  new Date(filterByDate.end);
      dateTo = new Date(dateTo.setDate(dateTo.getDate()+1));
      dateTo.setHours(0,0,0,0);
      const param  = {
        dateFrom,
        dateTo,
        gymIDs:Member.gymId,
        branchIDs:Member.branchId,
        noLimit:"noLimit",
        assigedUser:selectedUserApt.userId
      };

      const response = await getAllAppointment(user._id,token,param);
      if(!response.error){
        setAppointments(response);
        //console.log(response)
        GetAppointmentInfo(response);
      }
    }catch(error){
      console.error(error);
      await stopLoader();
    }

  }


  const GetAppointmentSlotsParam = () =>{
    const param={
      noLimit:"noLimit",
      gymId:Member.gymId,
      branchId:Member.branchId
    }

    if(userSearchKey) param.q = userSearchKey;

    return param;
  }

  const GetAllAppointmentSlots = async (isReload) =>{
    try{
      const param = GetAppointmentSlotsParam();
      //alert(JSON.stringify(param))
      const response = await getAllAppointmentSlots(user._id,token,param);

      // console.log("Hello resp");
      // console.log(response);

      if(response.error){
        
      }else{
        
        setAppointmentSlots(response);
      }
    }catch(error){
      //error
    }
  }

  const GetMember = async memberId =>{
    try{
      const response = await getMember(user._id,token,memberId);
      if(!response.error){
        setMember(response);
      }

    }catch(error){
      
    }
  }


  const getAppointMent = (slot,appointments=[]) =>{
    let result;


    for(const appointment of appointments){
      const bookingDetail = appointment.bookingDetail;
        if(
          bookingDetail &&
          slot &&
          bookingDetail.slotTime &&
          slot.slotTime && 
          bookingDetail.slotRange &&
          slot.slotRange &&
          bookingDetail.slotRange.startTime &&
          bookingDetail.slotRange.endTime &&
          slot.slotRange.startTime &&
          slot.slotRange.endTime &&
          bookingDetail.slotRange.startTime.hr == slot.slotRange.startTime.hr &&
          bookingDetail.slotRange.startTime.min == slot.slotRange.startTime.min &&
          bookingDetail.slotRange.startTime.period == slot.slotRange.startTime.period &&
          bookingDetail.slotRange.endTime.hr == slot.slotRange.endTime.hr &&
          bookingDetail.slotRange.endTime.min == slot.slotRange.endTime.min &&
          bookingDetail.slotRange.endTime.period == slot.slotRange.endTime.period &&
          bookingDetail.slotTime.startTime &&
          bookingDetail.slotTime.endTime &&
          bookingDetail.slotTime.startTime.hr == slot.slotTime.startTime.hr &&
          bookingDetail.slotTime.startTime.min == slot.slotTime.startTime.min &&
          bookingDetail.slotTime.startTime.period == slot.slotTime.startTime.period &&
          bookingDetail.slotTime.endTime.hr == slot.slotTime.endTime.hr &&
          bookingDetail.slotTime.endTime.min == slot.slotTime.endTime.min &&
          bookingDetail.slotTime.endTime.period == slot.slotTime.endTime.period &&
          slot.dateString &&
          bookingDetail.appointmentDateString &&
          slot.dateString == bookingDetail.appointmentDateString 
        ){
         result = appointment;
        }



    }


    return result;
  }

  const GetAppointmentInfo = (appointments=[]) =>{


    setDateStrings(oldstate=>{

      let index = 0;
      for(const data of dateStrings){
        let result = []
        if(selectedUserApt){
          const dayIndex = new Date(data.date).getDay();
          const dayKey = client.config.weekDays[dayIndex].toLowerCase();
          const weekDayData = selectedUserApt.weekdays[dayKey];

          for(const slot of weekDayData.slots){
            const slotRange = slot.slotRange;
            const availableSlots = slot.availableSlots;
            // alert(JSON.stringify(availableSlots));
            for(const avlSlot of availableSlots){
              const payload ={
                id:`${data.dateString.split("/").join("_")}_${avlSlot.startTime.hr}_${avlSlot.startTime.min}_${avlSlot.startTime.period}_${avlSlot.endTime.hr}_${avlSlot.endTime.min}_${avlSlot.endTime.period}_${slotRange.startTime.hr}_${slotRange.startTime.min}_${slotRange.startTime.period}_${slotRange.endTime.hr}_${slotRange.endTime.min}_${slotRange.endTime.period}`,
                slotRange,
                slotTime:{
                  startTime:avlSlot.startTime,
                  endTime:avlSlot.endTime
                },
                dayName:client.config.weekDayDisplayNames[client.config.weekDays[dayIndex]],
                date:data.date,
                dateString:data.dateString
              }
    
              let check = getAppointMent(payload,appointments);
              if(!check){
                result.push(payload);
              }else{
                let color = GetColor(check);  
                if(color && color=="#9F201C"){
                  payload.color = color;
                  result.push(payload);
                }else{
                  result.push(payload);
                }
              }


            }
          }

          oldstate[index].slots = result;
        }
        index++;
      }


      return [...oldstate];
    })
  }

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
    }

    if(id == "group-class-type"){
      setGroupClassDropdownOpen(!isGroupClassDropdownOpen)
    }
  };

  const handleMenuToggle = (menu) => {
    setSelectedSessionType(menu)
  }

  const toggleDateRange = () => {
    setDateRangeEnabled(!isDateRangeEnabled)
  } 

  useEffect(()=>{
    if(selectedSlot && Member && selectedUserApt){
      setButtonLock(false);
    }else{
      setButtonLock(true)
    }
  },[selectedSlot,Member,selectedUserApt]);

  useEffect(async ()=>{
   try{
    if(selectedUserApt){
      await startLoader()
      await GetAppointments();
      await stopLoader();
    }
   }catch(error){
    await stopLoader();
   }
  },[selectedUserApt]);

  useEffect(async ()=>{
    if(Member){
      try{
        await startLoader();
        await GetAllAppointmentSlots();
        await stopLoader();
      }catch(error){
        await stopLoader();
      }
    }
  },[userSearchKey,Member]);

  useEffect(()=>{
    setSelectedUserApt(props.selectedUserApt)
  },[props]);

  useEffect(async ()=>{
    try{
      const memberId = localStorage.getItem("memberId");
      if(memberId){
        let list = []
        let date = new Date(filterByDate.start);
        for(let index = 0; index < 7; index++){
          
          let tempDate = new Date(new Date(date).setDate(new Date(date).getDate()+index));
          list.push({
            dateString:formatDateTime(tempDate),
            date:tempDate,
            slots:[]
          });
        }
        setDateStrings(list);
        await startLoader();
        await GetMember(memberId)
        await stopLoader()
      }
    }catch(error){
      alert(error)
      await stopLoader();
    }
  },[]);


  useEffect(async() => {
    try{
      await GetAllParameters();
    }catch(err){
      console.log(err)
    }
  },[])



  return(
    <div className='w-full h-full' style={{overflowY:"auto", paddingBottom:"100px"}}>
      {/* <div className="p-l-12 p-r-12 m-t-20 w-full">
        <div className="toggle-menu-container d-flex">
          <div onClick={()=>handleMenuToggle("class")} className={`menu-container d-flex ${selectedSessionType == "class" && "gos-active-menu"}`}>
            <p className={`flex-item margin-auto fs-16 font-weight-700 ${selectedSessionType == "class" ? "active-text" : "inactive-text"}`}>Group Class</p>
          </div>
          <div onClick={()=>handleMenuToggle("appointment")} className={`menu-container d-flex ${selectedSessionType == "appointment" && "gos-active-menu"}`}>
            <p className={`flex-item margin-auto fs-16 font-weight-700 ${selectedSessionType == "appointment" ? "active-text" : "inactive-text"}`}>Appointment</p>
          </div>
        </div>
        <div className="dashboard-data-saperator flex-item w-full" style={{background: "var(--darkBlue)", marginBottom:"0"}}  />
      </div> */}

      {
        selectedSessionType == "class" ? (
          <div className="w-full" style={{height:"90%", overflowY:"auto"}}>
            {
              isDateRangeEnabled ? (
                <div className="d-flex space-between p-l-12 p-r-12 m-t-16 m-b-20">
                  <div onClick={()=>toggleInputFields('date-range')} className={`${(currentElementId == 'date-range' || dateRange) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == 'date-range' || dateRange) ? "1px solid var(--darkBlue)" : "", width: "88%" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == 'date-range' || dateRange) ? "10px" : "14px", color: (currentElementId == 'date-range' || dateRange) ? "var(--darkBlue)" : "", transition: "180ms" }}>Date Rage</p>
                    </div>
                    <input value={dateRange} className={`${(currentElementId == 'date-range' || dateRange) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="DD/MM/YYYY - DD/MM/YYYY" />
                  </div>
                  <svg onClick={toggleDateRange} className="flex-item" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.1471 27.4173C10.402 27.4173 7.22925 26.1185 4.62897 23.5207C2.02997 20.9217 0.730469 17.7503 0.730469 14.0064C0.730469 10.2625 2.02997 7.08979 4.62897 4.48823C7.22797 1.88668 10.4007 0.585262 14.1471 0.583984C16.4254 0.583984 18.5587 1.12512 20.5469 2.2074C22.5338 3.28968 24.1355 4.80065 25.352 6.74032V0.583984H27.2686V10.6082H17.2445V8.69148H24.3361C23.3369 6.78121 21.9326 5.27151 20.1233 4.1624C18.314 3.05329 16.3219 2.49937 14.1471 2.50065C10.9527 2.50065 8.23741 3.61871 6.0013 5.85482C3.76519 8.09093 2.64714 10.8062 2.64714 14.0007C2.64714 17.1951 3.76519 19.9104 6.0013 22.1465C8.23741 24.3826 10.9527 25.5007 14.1471 25.5007C16.6069 25.5007 18.827 24.7979 20.8076 23.3923C22.7881 21.9868 24.1777 20.134 24.9763 17.834H27.0118C26.1659 20.7039 24.5597 23.0186 22.1933 24.7781C19.8269 26.5376 17.1448 27.4173 14.1471 27.4173Z" fill="var(--darkBlue)"/>
                  </svg>
                </div>
              ) : (
                <div className="d-flex space-between p-l-12 p-r-12 m-t-16 m-b-20">
                  <div className="flex-item">
                    <p className="flex-item fs-16 font-weight-700 color-dark-blue" style={{lineHeight:"16px"}}>Today’s Classes</p>
                    <p className="fs-12" style={{fontSize:"12px"}}>Select a class to book</p>
                  </div>
                  <div onClick={toggleDateRange} className="d-flex bg-white p-l-12 p-r-12" style={{borderRadius:"20px", height:"40px"}}>
                    <svg className="flex-item m-r-4" width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.74898 7.5838C9.91316 7.5838 10.0706 7.51858 10.1867 7.40248C10.3028 7.28639 10.368 7.12893 10.368 6.96475C10.368 6.80057 10.3028 6.64311 10.1867 6.52702C10.0706 6.41092 9.91316 6.3457 9.74898 6.3457C9.5848 6.3457 9.42734 6.41092 9.31124 6.52702C9.19515 6.64311 9.12993 6.80057 9.12993 6.96475C9.12993 7.12893 9.19515 7.28639 9.31124 7.40248C9.42734 7.51858 9.5848 7.5838 9.74898 7.5838ZM9.74898 10.06C9.91316 10.06 10.0706 9.99477 10.1867 9.87867C10.3028 9.76258 10.368 9.60512 10.368 9.44094C10.368 9.27676 10.3028 9.1193 10.1867 9.00321C10.0706 8.88711 9.91316 8.82189 9.74898 8.82189C9.5848 8.82189 9.42734 8.88711 9.31124 9.00321C9.19515 9.1193 9.12993 9.27676 9.12993 9.44094C9.12993 9.60512 9.19515 9.76258 9.31124 9.87867C9.42734 9.99477 9.5848 10.06 9.74898 10.06ZM7.27279 6.96475C7.27279 7.12893 7.20757 7.28639 7.09147 7.40248C6.97538 7.51858 6.81792 7.5838 6.65374 7.5838C6.48956 7.5838 6.3321 7.51858 6.21601 7.40248C6.09991 7.28639 6.03469 7.12893 6.03469 6.96475C6.03469 6.80057 6.09991 6.64311 6.21601 6.52702C6.3321 6.41092 6.48956 6.3457 6.65374 6.3457C6.81792 6.3457 6.97538 6.41092 7.09147 6.52702C7.20757 6.64311 7.27279 6.80057 7.27279 6.96475ZM7.27279 9.44094C7.27279 9.60512 7.20757 9.76258 7.09147 9.87867C6.97538 9.99477 6.81792 10.06 6.65374 10.06C6.48956 10.06 6.3321 9.99477 6.21601 9.87867C6.09991 9.76258 6.03469 9.60512 6.03469 9.44094C6.03469 9.27676 6.09991 9.1193 6.21601 9.00321C6.3321 8.88711 6.48956 8.82189 6.65374 8.82189C6.81792 8.82189 6.97538 8.88711 7.09147 9.00321C7.20757 9.1193 7.27279 9.27676 7.27279 9.44094ZM3.5585 7.5838C3.72268 7.5838 3.88014 7.51858 3.99623 7.40248C4.11233 7.28639 4.17755 7.12893 4.17755 6.96475C4.17755 6.80057 4.11233 6.64311 3.99623 6.52702C3.88014 6.41092 3.72268 6.3457 3.5585 6.3457C3.39432 6.3457 3.23686 6.41092 3.12077 6.52702C3.00467 6.64311 2.93945 6.80057 2.93945 6.96475C2.93945 7.12893 3.00467 7.28639 3.12077 7.40248C3.23686 7.51858 3.39432 7.5838 3.5585 7.5838ZM3.5585 10.06C3.72268 10.06 3.88014 9.99477 3.99623 9.87867C4.11233 9.76258 4.17755 9.60512 4.17755 9.44094C4.17755 9.27676 4.11233 9.1193 3.99623 9.00321C3.88014 8.88711 3.72268 8.82189 3.5585 8.82189C3.39432 8.82189 3.23686 8.88711 3.12077 9.00321C3.00467 9.1193 2.93945 9.27676 2.93945 9.44094C2.93945 9.60512 3.00467 9.76258 3.12077 9.87867C3.23686 9.99477 3.39432 10.06 3.5585 10.06Z" fill="#2B2828"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.55891 0C3.68204 0 3.80013 0.0489157 3.8872 0.135986C3.97428 0.223057 4.02319 0.341149 4.02319 0.464286V0.936619C4.433 0.928571 4.88429 0.928571 5.38076 0.928571H7.92691C8.424 0.928571 8.87529 0.928571 9.2851 0.936619V0.464286C9.2851 0.341149 9.33401 0.223057 9.42108 0.135986C9.50815 0.0489157 9.62625 0 9.74938 0C9.87252 0 9.99061 0.0489157 10.0777 0.135986C10.1648 0.223057 10.2137 0.341149 10.2137 0.464286V0.976238C10.3746 0.988619 10.5269 1.0041 10.6711 1.02329C11.3967 1.1211 11.9841 1.32662 12.4478 1.78967C12.9109 2.25333 13.1164 2.84081 13.2142 3.56633C13.3089 4.27205 13.3089 5.17276 13.3089 6.31057V7.618C13.3089 8.75581 13.3089 9.65714 13.2142 10.3622C13.1164 11.0878 12.9109 11.6752 12.4478 12.1389C11.9841 12.602 11.3967 12.8075 10.6711 12.9053C9.96543 13 9.06472 13 7.92691 13H5.382C4.24419 13 3.34286 13 2.63776 12.9053C1.91224 12.8075 1.32476 12.602 0.861095 12.1389C0.398048 11.6752 0.192524 11.0878 0.0947143 10.3622C0 9.65652 0 8.75581 0 7.618V6.31057C0 5.17276 0 4.27143 0.0947143 3.56633C0.192524 2.84081 0.398048 2.25333 0.861095 1.78967C1.32476 1.32662 1.91224 1.1211 2.63776 1.02329C2.782 1.0041 2.93491 0.988619 3.09524 0.976238V0.464286C3.09524 0.341257 3.14407 0.223258 3.23101 0.136205C3.31794 0.0491521 3.43588 0.000164039 3.55891 0ZM2.76033 1.94381C2.13819 2.02738 1.77914 2.18462 1.51729 2.44648C1.25543 2.70833 1.09819 3.06738 1.01462 3.69014C1.00038 3.79538 0.988619 3.90681 0.978714 4.02381H12.3296C12.3197 3.90619 12.3079 3.79538 12.2937 3.68952C12.2101 3.06738 12.0529 2.70833 11.791 2.44648C11.5291 2.18462 11.1701 2.02738 10.5473 1.94381C9.91157 1.85838 9.07276 1.85714 7.89224 1.85714H5.41605C4.23552 1.85714 3.39733 1.85838 2.76033 1.94381ZM0.927952 6.34524C0.927952 5.81657 0.927952 5.35662 0.936 4.95238H12.3723C12.3803 5.35662 12.3803 5.81657 12.3803 6.34524V7.58333C12.3803 8.76386 12.3791 9.60267 12.2937 10.239C12.2101 10.8612 12.0529 11.2202 11.791 11.4821C11.5291 11.744 11.1701 11.9012 10.5473 11.9848C9.91157 12.0702 9.07276 12.0714 7.89224 12.0714H5.41605C4.23552 12.0714 3.39733 12.0702 2.76033 11.9848C2.13819 11.9012 1.77914 11.744 1.51729 11.4821C1.25543 11.2202 1.09819 10.8612 1.01462 10.2384C0.929191 9.60267 0.927952 8.76386 0.927952 7.58333V6.34524Z" fill="#2B2828"/>
                    </svg>
                    <p className="flex-item">Date Range</p>
                  </div>
                </div>
              )
            }
            <div className="p-l-12 p-r-12 m-b-20">
              <div onClick={()=>toggleInputFields('group-class-type')} className={`${(currentElementId == "group-class-type" || selectedGroupClass) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "group-class-type" || selectedGroupClass) ? "1px solid var(--darkBlue)" : "" }}>
                <div className="flex-item d-flex">
                  <svg className="flex-item m-r-4" width={(currentElementId == "group-class-type" || selectedGroupClass) ? "12" : "18"} height={(currentElementId == "group-class-type" || selectedGroupClass) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.37735 2.24821C5.67548 2.24821 5.9614 2.12977 6.17221 1.91896C6.38302 1.70815 6.50145 1.42223 6.50145 1.1241C6.50145 0.825972 6.38302 0.540052 6.17221 0.329242C5.9614 0.118432 5.67548 0 5.37735 0C5.07922 0 4.7933 0.118432 4.58249 0.329242C4.37168 0.540052 4.25325 0.825972 4.25325 1.1241C4.25325 1.42223 4.37168 1.70815 4.58249 1.91896C4.7933 2.12977 5.07922 2.24821 5.37735 2.24821ZM3.11915 3.31785C2.80765 3.39529 2.59507 3.5117 2.42346 3.65608C2.16616 3.87291 1.95833 4.18566 1.67755 4.67727C1.6118 4.79231 1.50304 4.87653 1.37519 4.91138C1.24735 4.94623 1.11089 4.92887 0.995847 4.86312C0.880801 4.79736 0.796589 4.6886 0.761735 4.56076C0.726881 4.43291 0.74424 4.29646 0.809995 4.18141C1.08952 3.69255 1.37205 3.23517 1.77997 2.89194C2.20563 2.53323 2.72672 2.33039 3.4294 2.2522C3.72317 2.21973 4.04641 2.22622 4.34942 2.36137C4.66742 2.5035 4.89973 2.75805 5.0581 3.09828C5.27143 3.55616 5.43006 3.82869 5.55696 3.98657C5.61816 4.06251 5.66087 4.09773 5.6851 4.11347C5.70434 4.12596 5.71258 4.12696 5.71558 4.12746C5.73731 4.12995 5.80801 4.12746 6.01484 4.03578C6.10502 3.99581 6.20344 3.94785 6.32384 3.88915L6.35257 3.87516C6.49982 3.80249 6.6484 3.73254 6.79822 3.66533C6.91917 3.61222 7.05623 3.60919 7.17942 3.65688C7.30261 3.70458 7.40189 3.79911 7.45556 3.91982C7.50922 4.04053 7.5129 4.17757 7.46579 4.30098C7.41867 4.42439 7.3246 4.52412 7.20414 4.57835C7.06531 4.64066 6.92765 4.70553 6.79122 4.77294L6.7585 4.78893C6.64334 4.84513 6.52743 4.90184 6.41877 4.9498C6.19395 5.04922 5.90668 5.15713 5.59518 5.11941C5.26644 5.07945 5.01314 4.89384 4.80456 4.64479L4.12185 5.96199L5.0661 7.19051C5.1223 7.26395 5.15703 7.35138 5.16677 7.44331L5.3746 9.44072C5.38252 9.50652 5.37726 9.57325 5.35914 9.63701C5.34102 9.70077 5.31039 9.76028 5.26903 9.81208C5.22768 9.86388 5.17644 9.90694 5.11828 9.93874C5.06012 9.97054 4.99622 9.99046 4.93029 9.99732C4.86437 10.0042 4.79773 9.99785 4.73428 9.97871C4.67082 9.95956 4.6118 9.92798 4.56067 9.8858C4.50954 9.84362 4.46731 9.79169 4.43645 9.73304C4.40558 9.67438 4.3867 9.61016 4.3809 9.54413L4.18755 7.68736L3.61401 6.94096L3.60901 6.9502L3.58803 6.90724L2.52837 5.52834C2.47628 5.46056 2.44245 5.38056 2.43012 5.29597C2.41779 5.21139 2.42736 5.12505 2.45793 5.04522L3.11915 3.31785Z" fill={(currentElementId == "group-class-type" || selectedGroupClass) ? "var(--darkBlue)" : "#6d6d6d"} />
                    <path d="M2.36235 6.24658L1.99464 7.23579L0.545797 7.12088C0.479925 7.11477 0.413495 7.12179 0.35036 7.14156C0.287225 7.16132 0.228644 7.19342 0.178016 7.236C0.127387 7.27859 0.0857207 7.3308 0.0554334 7.38962C0.0251461 7.44843 0.00684141 7.51268 0.00158161 7.57862C-0.00367819 7.64457 0.00421159 7.7109 0.0247932 7.77378C0.0453747 7.83665 0.0782381 7.89481 0.121476 7.94488C0.164714 7.99495 0.217466 8.03593 0.27667 8.06545C0.335875 8.09497 0.400352 8.11244 0.466361 8.11684L2.2919 8.26172C2.40025 8.27035 2.50845 8.2434 2.60009 8.18498C2.69174 8.12655 2.76183 8.03984 2.79975 7.93798L3.08077 7.18159L2.36235 6.24658Z" fill={(currentElementId == "group-class-type" || selectedGroupClass) ? "var(--darkBlue)" : "#6d6d6d"} />
                  </svg>
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "group-class-type" || selectedGroupClass) ? "10px" : "14px", color: (currentElementId == "group-class-type" || selectedGroupClass) ? "var(--darkBlue)" : "", transition: "180ms" }}>Group Class Name*</p>
                </div>
                <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                  <svg className="flex-item" style={{ transform: isGroupClassDropdownOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                  </svg>
                </div>
                <input id="group-class-type" className={`${(currentElementId == "group-class-type" || selectedGroupClass) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Group Class" value={selectedGroupClass} style={{ pointerEvents: "none", textTransform: 'capitalize' }} disabled/>
                {
                  isGroupClassDropdownOpen && (
                    <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                      {/* By Default All will be selected -  */}
                      <div className="global-input-field-arrow-dropdown-item">
                        <p className="flex-item">All Classes</p>
                      </div>
                      {
                        [1,2,3,4,5].map(data=>{
                          return (
                            <div className="global-input-field-arrow-dropdown-item">
                              <p className="flex-item">Group Classes Name</p>
                            </div>
                          );
                        })
                      }
                    </div>
                  )
                }
              </div>
            </div>
            <div className="p-l-12 p-r-12 m-b-20">
              {
                [1,2,3,4,5,6,,7,8,9,10,11,12].map(data => {
                  return[
                    <div className="w-full">
                      <p className="flex-item fs-14 color-dark-blue font-weight-700 m-b-8">Yoga Class at Yoga Class for 2 hrs</p>
                      <div className="d-flex space-between">
                        <div className="flex-item d-flex">
                          <svg className="flex-item" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.9395 19.299C25.3573 19.299 25.758 19.1331 26.0534 18.8376C26.3489 18.5422 26.5148 18.1415 26.5148 17.7237C26.5148 17.3059 26.3489 16.9053 26.0534 16.6098C25.758 16.3144 25.3573 16.1484 24.9395 16.1484C24.5217 16.1484 24.1211 16.3144 23.8256 16.6098C23.5302 16.9053 23.3642 17.3059 23.3642 17.7237C23.3642 18.1415 23.5302 18.5422 23.8256 18.8376C24.1211 19.1331 24.5217 19.299 24.9395 19.299ZM24.9395 25.6002C25.3573 25.6002 25.758 25.4342 26.0534 25.1388C26.3489 24.8434 26.5148 24.4427 26.5148 24.0249C26.5148 23.6071 26.3489 23.2064 26.0534 22.911C25.758 22.6156 25.3573 22.4496 24.9395 22.4496C24.5217 22.4496 24.1211 22.6156 23.8256 22.911C23.5302 23.2064 23.3642 23.6071 23.3642 24.0249C23.3642 24.4427 23.5302 24.8434 23.8256 25.1388C24.1211 25.4342 24.5217 25.6002 24.9395 25.6002ZM18.6384 17.7237C18.6384 18.1415 18.4724 18.5422 18.177 18.8376C17.8815 19.1331 17.4809 19.299 17.0631 19.299C16.6453 19.299 16.2446 19.1331 15.9492 18.8376C15.6538 18.5422 15.4878 18.1415 15.4878 17.7237C15.4878 17.3059 15.6538 16.9053 15.9492 16.6098C16.2446 16.3144 16.6453 16.1484 17.0631 16.1484C17.4809 16.1484 17.8815 16.3144 18.177 16.6098C18.4724 16.9053 18.6384 17.3059 18.6384 17.7237ZM18.6384 24.0249C18.6384 24.4427 18.4724 24.8434 18.177 25.1388C17.8815 25.4342 17.4809 25.6002 17.0631 25.6002C16.6453 25.6002 16.2446 25.4342 15.9492 25.1388C15.6538 24.8434 15.4878 24.4427 15.4878 24.0249C15.4878 23.6071 15.6538 23.2064 15.9492 22.911C16.2446 22.6156 16.6453 22.4496 17.0631 22.4496C17.4809 22.4496 17.8815 22.6156 18.177 22.911C18.4724 23.2064 18.6384 23.6071 18.6384 24.0249ZM9.18662 19.299C9.60441 19.299 10.0051 19.1331 10.3005 18.8376C10.5959 18.5422 10.7619 18.1415 10.7619 17.7237C10.7619 17.3059 10.5959 16.9053 10.3005 16.6098C10.0051 16.3144 9.60441 16.1484 9.18662 16.1484C8.76883 16.1484 8.36814 16.3144 8.07272 16.6098C7.7773 16.9053 7.61133 17.3059 7.61133 17.7237C7.61133 18.1415 7.7773 18.5422 8.07272 18.8376C8.36814 19.1331 8.76883 19.299 9.18662 19.299ZM9.18662 25.6002C9.60441 25.6002 10.0051 25.4342 10.3005 25.1388C10.5959 24.8434 10.7619 24.4427 10.7619 24.0249C10.7619 23.6071 10.5959 23.2064 10.3005 22.911C10.0051 22.6156 9.60441 22.4496 9.18662 22.4496C8.76883 22.4496 8.36814 22.6156 8.07272 22.911C7.7773 23.2064 7.61133 23.6071 7.61133 24.0249C7.61133 24.4427 7.7773 24.8434 8.07272 25.1388C8.36814 25.4342 8.76883 25.6002 9.18662 25.6002Z" fill="#777777"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.18916 0C9.50251 0 9.80302 0.124476 10.0246 0.346044C10.2462 0.567612 10.3706 0.868123 10.3706 1.18147V2.38342C11.4135 2.36294 12.5619 2.36294 13.8252 2.36294H20.3044C21.5694 2.36294 22.7178 2.36294 23.7606 2.38342V1.18147C23.7606 0.868123 23.8851 0.567612 24.1066 0.346044C24.3282 0.124476 24.6287 0 24.9421 0C25.2554 0 25.5559 0.124476 25.7775 0.346044C25.9991 0.567612 26.1235 0.868123 26.1235 1.18147V2.48423C26.5331 2.51574 26.9206 2.55512 27.2877 2.60396C29.1339 2.85285 30.6289 3.37585 31.8088 4.55417C32.9871 5.73406 33.5101 7.22901 33.759 9.07525C34 10.8711 34 13.1631 34 16.0585V19.3855C34 22.2809 34 24.5745 33.759 26.3688C33.5101 28.215 32.9871 29.71 31.8088 30.8899C30.6289 32.0682 29.1339 32.5912 27.2877 32.8401C25.4919 33.0811 23.1998 33.0811 20.3044 33.0811H13.8284C10.933 33.0811 8.63939 33.0811 6.84513 32.8401C4.99889 32.5912 3.50394 32.0682 2.32404 30.8899C1.14572 29.71 0.622728 28.215 0.373832 26.3688C0.132812 24.573 0.132812 22.2809 0.132812 19.3855V16.0585C0.132812 13.1631 0.132812 10.8695 0.373832 9.07525C0.622728 7.22901 1.14572 5.73406 2.32404 4.55417C3.50394 3.37585 4.99889 2.85285 6.84513 2.60396C7.21217 2.55512 7.60127 2.51574 8.00927 2.48423V1.18147C8.00927 0.868396 8.13353 0.568124 8.35476 0.346601C8.57598 0.125077 8.87609 0.000417429 9.18916 0ZM7.15704 4.94641C5.57387 5.15908 4.6602 5.5592 3.99385 6.22555C3.3275 6.8919 2.92738 7.80557 2.71471 9.39031C2.67848 9.65811 2.64855 9.94166 2.62335 10.2394H31.5079C31.4827 9.94009 31.4528 9.65811 31.4165 9.38873C31.2039 7.80557 30.8037 6.8919 30.1374 6.22555C29.471 5.5592 28.5574 5.15908 26.9726 4.94641C25.3548 4.72902 23.2203 4.72587 20.2162 4.72587H13.915C10.911 4.72587 8.77801 4.72902 7.15704 4.94641ZM2.49417 16.1467C2.49417 14.8014 2.49417 13.631 2.51465 12.6023H31.6166C31.6371 13.631 31.6371 14.8014 31.6371 16.1467V19.2973C31.6371 22.3014 31.6339 24.4359 31.4165 26.0553C31.2039 27.6385 30.8037 28.5522 30.1374 29.2185C29.471 29.8848 28.5574 30.285 26.9726 30.4976C25.3548 30.715 23.2203 30.7182 20.2162 30.7182H13.915C10.911 30.7182 8.77801 30.715 7.15704 30.4976C5.57387 30.285 4.6602 29.8848 3.99385 29.2185C3.3275 28.5522 2.92738 27.6385 2.71471 26.0537C2.49732 24.4359 2.49417 22.3014 2.49417 19.2973V16.1467Z" fill="#777777"/>
                          </svg>
                          <div className="flex-item m-l-8">
                            <p className="flex-item fs-16 m-b-4 font-weight-600" style={{lineHeight:"16px"}}>14/06/2025 - <span style={{color:"#E33A34"}}>12:00 PM</span></p>
                            <p className="flex-item fs-12" style={{lineHeight:"12px", color:"#4d4d4d"}}>2/3 booked</p>
                          </div>
                        </div>
                        <div className="d-flex flex-item">
                          <div className={`global-button-container global-button-container-active d-flex flex-item w-full`} style={{borderRadius:"25px"}}>
                            <p className="flex-item">Book</p>
                          </div>
                        </div>
                      </div>
                    </div>,
                    <svg className="m-t-20 m-b-20" width="100%" height="2" viewBox="0 0 374 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <line y1="1" x2="374.001" y2="1" stroke="#A1A1A1" stroke-dasharray="2 2"/>
                    </svg>
                  ]
                })
              }
            </div>
          </div>
        ) : (
          <div className="w-full">
            <div className="w-full" style={{padding:"12px", height:"90%"}}>
              <div className="w-full m-t-6">
                <div onClick={()=>toggleInputFields('appointment-type')} className={`${currentElementId == "appointment-type" || selectedAppointmentType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "appointment-type" || selectedAppointmentType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px" }}>
                  <div className="flex-item d-flex" style={{marginTop: (currentElementId == "appointment-type" || selectedAppointmentType) ? "4px" : ""}}>
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "appointment-type" || selectedAppointmentType) ? "10px" : "16px", lineHeight: (currentElementId == "appointment-type" || selectedAppointmentType) ? "10px" : "16px", color: (currentElementId == "appointment-type" || selectedAppointmentType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Appointment Type</p>
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" style={{ transform: currentElementId == "appointment-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                    </svg>
                  </div>
                  {
                    selectedAppointmentType ? (
                      <div className="w-full d-flex m-t-8 m-b-8">
                        <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{selectedAppointmentType}</p>
                      </div>
                    ) : 
                    <div className={`${(currentElementId == "appointment-type" || selectedAppointmentType) ? "active-input-field" : "inactive-input-field"} w-full d-flex m-t-6`}>
                      <p id="appointment-type" className={`color-grey-06 font-weight-300 fs-18 m-t-15`}>{selectedAppointmentType ? selectedAppointmentType : "Select Appointment Type"}</p>
                    </div>
                  }
                  
                  {
                    currentElementId == "appointment-type" && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : selectedAppointmentType && "70px"}}>
                        <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                          {
                            parameters.map((data, index) => {
                              return (
                                <div onClick={()=>selectAppointmentType(data.name)} className="global-input-field-arrow-dropdown-item d-flex">
                                  <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data.name}</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
              {
                selectedAppointmentType && (
                  <div onClick={()=>toggleUserList()} className="select-apt-user-container bg-white d-flex space-between m-t-12">
                    {
                      selectedUserApt ? (
                        <div className="w-full d-flex">
                          {/* <div className="profile-img m-r-8 m-l-1">
                            <img className="flex-item" src={`https://picsum.photos/200/300`} />
                          </div> */}
                          {
                              selectedUserApt.user[0].profileID ? (
                                  <img className="profile-img m-r-8 m-l-1" src={`${client.config.API_URL}/image/file/${selectedUserApt.user[0].profileID}/auto/auto/70`} loading='lazy' />
                              ) : (
                                <div className="profile-img m-r-8 m-l-12 flex-item d-flex" style={{backgroundColor: "#5d883c", width:"40px", height:"40px"}}>
                                  <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: "16px"}}>{`${selectedUserApt.user[0].name}`.trim()[0]}</p>
                                </div>
                              ) 
                            }
                          <div className="flex-item">
                            <p className="fs-16 font-weight-700" style={{lineHeight:"16px"}}>{selectedUserApt.user[0].name}</p>
                            <p className="fs-12 color-grey-02 m-t-4" style={{lineHeight:"12px"}}>{selectedUserApt.branch[0].name}</p>
                          </div>
                        </div>
                      ) : (
                        <p className="m-l-20 flex-item font-weight-700 fs-18">Select User</p>
                      )
                    }
                    <svg className="flex-item m-r-20" style={{transform: isUserListOpen ? "rotate(180deg)" : "rotate(0deg)", transition:"180ms"}} width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L7.5 8L14 1" stroke="var(--darkBlue)" stroke-width="2" stroke-linecap="round"/>
                    </svg>
          
                    {
                      isUserListOpen && (
                        <div className="select-user-container slideTopToBottom p-l-0 p-r-0" onClick={e=>e.stopPropagation()}>
                          <SearchFilter searchType={"by Name"} count={appointmentslots.length} isSearchEnabled={true} searchingData={handleSearchingData} isFilterEnabled={false}/>
                          <div className="w-full p-l-12 p-r-12">
                            {/* <div className="user-role-types-container d-flex m-b-12">
                              {
                                userRoleTypes.map(userRole => {
                                  return(
                                    <div className="d-flex user-role-chip m-r-12">
                                      <p className="flex-item">{userRole}</p>
                                    </div>
                                  )
                                })
                              }
                            </div> */}
                            <div className="user-list-scroll-container">
                              {
                                appointmentslots.map((appointmentSlot, index) => {
                                  return(
                                    <div onClick={()=>handleSelectUser(appointmentSlot)} className='d-flex flex-item w-full p-b-12 p-t-12' style={{borderBottom: appointmentslots.length != index + 1 && '1px solid #ffffff'}}>
                                      {
                                        appointmentSlot.user[0].profileID ?
                                          <div className='tr-profile-image d-flex flex-item m-r-8'>
                                            <img src={`${client.config.API_URL}/image/file/${appointmentSlot.user[0].profileID}/auto/auto/70`} loading='lazy' className="gym-logo" />
                                          </div>
                                          : <div className="tr-profile-image d-flex flex-item m-r-8">
                                            <p className='flex-item margin-auto'>{`${appointmentSlot.user[0].name}`.trim()[0]}</p>
                                          </div>
                                      }
                                      <div className="flex-item" style={{width:"80%"}}>
                                        <p style={{lineHeight:"14px"}}>{appointmentSlot.user[0].name}</p>
                                        <p className='fs-10 color-grey-02 m-t-4' style={{lineHeight:"10px"}}>{getUserRole(appointmentSlot.user[0].role)}</p>
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
          
                          </div>
                        </div>
                      )
                    }
                  </div>
                )
              }

              {
                (selectedUserApt && selectedAppointmentType) ? (
                  <div className="w-full m-t-20" style={{height:"90%"}}>
                    <div className="d-flex space-between m-b-12">
                      <p className="flex-item fs-17 color-dark-blue font-weight-700">Available Slots</p>
                      <div className="d-flex bg-dark-blue p-l-8 p-r-8" style={{width:"auto", height: "30px", borderRadius:"15px",visibility:'hidden'}}>
                        <svg className="flex-item" width="16" height="18" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.4539 9.68694C12.6637 9.68694 12.8648 9.60363 13.0131 9.45534C13.1614 9.30705 13.2447 9.10592 13.2447 8.8962C13.2447 8.68649 13.1614 8.48536 13.0131 8.33707C12.8648 8.18878 12.6637 8.10547 12.4539 8.10547C12.2442 8.10547 12.0431 8.18878 11.8948 8.33707C11.7465 8.48536 11.6632 8.68649 11.6632 8.8962C11.6632 9.10592 11.7465 9.30705 11.8948 9.45534C12.0431 9.60363 12.2442 9.68694 12.4539 9.68694ZM12.4539 12.8499C12.6637 12.8499 12.8648 12.7666 13.0131 12.6183C13.1614 12.47 13.2447 12.2689 13.2447 12.0591C13.2447 11.8494 13.1614 11.6483 13.0131 11.5C12.8648 11.3517 12.6637 11.2684 12.4539 11.2684C12.2442 11.2684 12.0431 11.3517 11.8948 11.5C11.7465 11.6483 11.6632 11.8494 11.6632 12.0591C11.6632 12.2689 11.7465 12.47 11.8948 12.6183C12.0431 12.7666 12.2442 12.8499 12.4539 12.8499ZM9.291 8.8962C9.291 9.10592 9.20769 9.30705 9.0594 9.45534C8.91111 9.60363 8.70998 9.68694 8.50027 9.68694C8.29055 9.68694 8.08942 9.60363 7.94113 9.45534C7.79284 9.30705 7.70953 9.10592 7.70953 8.8962C7.70953 8.68649 7.79284 8.48536 7.94113 8.33707C8.08942 8.18878 8.29055 8.10547 8.50027 8.10547C8.70998 8.10547 8.91111 8.18878 9.0594 8.33707C9.20769 8.48536 9.291 8.68649 9.291 8.8962ZM9.291 12.0591C9.291 12.2689 9.20769 12.47 9.0594 12.6183C8.91111 12.7666 8.70998 12.8499 8.50027 12.8499C8.29055 12.8499 8.08942 12.7666 7.94113 12.6183C7.79284 12.47 7.70953 12.2689 7.70953 12.0591C7.70953 11.8494 7.79284 11.6483 7.94113 11.5C8.08942 11.3517 8.29055 11.2684 8.50027 11.2684C8.70998 11.2684 8.91111 11.3517 9.0594 11.5C9.20769 11.6483 9.291 11.8494 9.291 12.0591ZM4.54659 9.68694C4.75631 9.68694 4.95744 9.60363 5.10573 9.45534C5.25402 9.30705 5.33733 9.10592 5.33733 8.8962C5.33733 8.68649 5.25402 8.48536 5.10573 8.33707C4.95744 8.18878 4.75631 8.10547 4.54659 8.10547C4.33688 8.10547 4.13575 8.18878 3.98746 8.33707C3.83917 8.48536 3.75586 8.68649 3.75586 8.8962C3.75586 9.10592 3.83917 9.30705 3.98746 9.45534C4.13575 9.60363 4.33688 9.68694 4.54659 9.68694ZM4.54659 12.8499C4.75631 12.8499 4.95744 12.7666 5.10573 12.6183C5.25402 12.47 5.33733 12.2689 5.33733 12.0591C5.33733 11.8494 5.25402 11.6483 5.10573 11.5C4.95744 11.3517 4.75631 11.2684 4.54659 11.2684C4.33688 11.2684 4.13575 11.3517 3.98746 11.5C3.83917 11.6483 3.75586 11.8494 3.75586 12.0591C3.75586 12.2689 3.83917 12.47 3.98746 12.6183C4.13575 12.7666 4.33688 12.8499 4.54659 12.8499Z" fill="white"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.54593 0C4.70322 0 4.85406 0.062482 4.96528 0.173701C5.0765 0.284919 5.13898 0.435764 5.13898 0.593051V1.19638C5.66245 1.1861 6.23889 1.1861 6.87306 1.1861H10.1254C10.7603 1.1861 11.3368 1.1861 11.8602 1.19638V0.593051C11.8602 0.435764 11.9227 0.284919 12.0339 0.173701C12.1451 0.062482 12.296 0 12.4533 0C12.6106 0 12.7614 0.062482 12.8726 0.173701C12.9838 0.284919 13.0463 0.435764 13.0463 0.593051V1.24699C13.2519 1.2628 13.4464 1.28257 13.6307 1.30708C14.5574 1.43202 15.3078 1.69454 15.9001 2.28601C16.4916 2.87827 16.7541 3.62868 16.879 4.55542C17 5.45686 17 6.60738 17 8.06075V9.73078C17 11.1841 17 12.3355 16.879 13.2361C16.7541 14.1628 16.4916 14.9132 15.9001 15.5055C15.3078 16.097 14.5574 16.3595 13.6307 16.4844C12.7292 16.6054 11.5787 16.6054 10.1254 16.6054H6.87464C5.42127 16.6054 4.26997 16.6054 3.36932 16.4844C2.44258 16.3595 1.69217 16.097 1.09991 15.5055C0.508442 14.9132 0.245918 14.1628 0.120982 13.2361C0 12.3347 0 11.1841 0 9.73078V8.06075C0 6.60738 0 5.45607 0.120982 4.55542C0.245918 3.62868 0.508442 2.87827 1.09991 2.28601C1.69217 1.69454 2.44258 1.43202 3.36932 1.30708C3.55356 1.28257 3.74887 1.2628 3.95367 1.24699V0.593051C3.95367 0.435901 4.01605 0.285176 4.12709 0.17398C4.23814 0.062784 4.38878 0.000209533 4.54593 0ZM3.52588 2.48291C2.7312 2.58965 2.27257 2.7905 1.93809 3.12498C1.60361 3.45946 1.40276 3.91809 1.29601 4.71357C1.27783 4.84799 1.2628 4.99032 1.25015 5.13977H15.7491C15.7364 4.98953 15.7214 4.84799 15.7032 4.71278C15.5964 3.91809 15.3956 3.45946 15.0611 3.12498C14.7266 2.7905 14.268 2.58965 13.4725 2.48291C12.6604 2.37378 11.589 2.3722 10.0811 2.3722H6.91814C5.4102 2.3722 4.33955 2.37378 3.52588 2.48291ZM1.18531 8.10503C1.18531 7.42974 1.18531 6.84222 1.19559 6.32587H15.8036C15.8139 6.84222 15.8139 7.42974 15.8139 8.10503V9.6865C15.8139 11.1944 15.8123 12.2659 15.7032 13.0787C15.5964 13.8734 15.3956 14.3321 15.0611 14.6665C14.7266 15.001 14.268 15.2019 13.4725 15.3086C12.6604 15.4177 11.589 15.4193 10.0811 15.4193H6.91814C5.4102 15.4193 4.33955 15.4177 3.52588 15.3086C2.7312 15.2019 2.27257 15.001 1.93809 14.6665C1.60361 14.3321 1.40276 13.8734 1.29601 13.078C1.18689 12.2659 1.18531 11.1944 1.18531 9.6865V8.10503Z" fill="white"/>
                        </svg>

                        {
                          selectedDateFilter && [
                            <p className="flex-item m-l-8 m-r-12 color-white">{selectedDateFilter}</p>,
                            <svg className="flex-item" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4.35352 15.0417L14.6452 4.75M14.6452 15.0417L4.35352 4.75" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          ]
                        }
                      </div>
                    </div>
                    
                    <div className="w-full p-b-40 no-scroll-bar" style={{ overflowY:"auto", height:"90%"}}>

                      {
                        (dateStrings.length>0 && dateStrings[0].slots && dateStrings[0].slots == 0) && (
                          <div className="appointment-day-slot-container bg-white m-b-12">
                            <div className="d-flex w-full space-between">
                              <div className="flex-item p-l-20">
                                <p className="flex-item fs-16 font-weight-600 color-dark-blue">Today</p>
                                <p className="flex-item fs-14 font-weight-700 m-t-6" style={{lineHeight:"20px"}}>No Appointment Slots<br/> available</p>
                              </div>
                              <img className="flex-item m-r-4" style={{width:"auto", height:"120px"}} src={NoAptImg} />
                            </div>
                          </div>

                        )
                      }
                      
                      {
                        dateStrings.map((data,index)=>{
                          if(data.slots.length == 0) return null;
                          return (
                            <div className="appointment-day-slot-container bg-white m-b-12">
                              <div className="appointment-day-slot-header d-flex space-between p-l-12 p-r-12">
                                <p className="flex-item fs-16 font-weight-700 color-dark-blue">{index == 0? "Today" : index == 1?"Tomorrow":data.dateString}</p>
                                <div className="d-flex bg-white" style={{padding:'6px 8px', borderRadius:"8px"}}>
                                  <p className="flex-item font-weight-700 fs-12" style={{lineHeight:"12px"}}>{data.slots.length} Slots Available</p>
                                </div>
                              </div>
                              <div className="d-flex-wrap space-between w-full p-l-12 p-t-8 p-b-8 p-r-12">
                                {
                                  data.slots.map(slot => {
                                    return(
                                      <div onClick={()=>handleSelectSlot(slot)} className={`time-slot-chips ${selectedSlot && slot.id == selectedSlot.id && `time-slot-chips-active`}  d-flex m-r-16 m-t-8 m-b-8`} style={{outlineColor:slot.color && `${slot.color}`,backgroundColor: (selectedSlot && slot.id == selectedSlot.id && slot.color) && `${slot.color}`}}>
                                        <p className="flex-item fs-12 margin-auto" style={slot.color?{lineHeight:'12px',color:!(selectedSlot && slot.id == selectedSlot.id) && slot.color}:{lineHeight:"12px"}}>{slot.slotTime.startTime.hr}:{slot.slotTime.startTime.min} {slot.slotTime.startTime.period} - {slot.slotTime.endTime.hr}:{slot.slotTime.endTime.min} {slot.slotTime.endTime.period}</p>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          )
                        })
                      }

            
      {/* 
                      <div className="appointment-day-slot-container bg-white m-b-12">
                        <div className="appointment-day-slot-header d-flex space-between p-l-12 p-r-12">
                          <p className="flex-item fs-16 font-weight-700 color-dark-blue">11/04/2025</p>
                          <div className="d-flex bg-white" style={{padding:'6px 8px', borderRadius:"8px"}}>
                            <p className="flex-item font-weight-700 fs-12" style={{lineHeight:"12px"}}>5 Slots Available</p>
                          </div>
                        </div>
                        <div className="d-flex-wrap w-full p-l-12 p-t-8 p-b-8 p-r-12">
                          {
                            [1,2,3,4,5,6,7,8,9,10].map(data => {
                              return(
                                // use class - time-slot-chips-active for selected time
                                <div className="time-slot-chips d-flex m-r-16 m-t-8 m-b-8">
                                  <p className="flex-item fs-12" style={{lineHeight:"12px"}}>12:00 PM</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div> */}
                    </div>
                  </div>
                ) : (
                  <div className="w-full">
                  </div>
                )
              }
            </div>
            <div className="w-full" style={{position:"absolute", bottom: 0, padding:"12px", background:"#f4f4f4"}}>
              <div onClick={isButtonLock?null:bookAppointment} className={`global-button-container ${isButtonLock?"global-button-container-inactive":"global-button-container-active"} d-flex flex-item w-full`} style={{height:"40px", borderRadius:"20px", margin: 0,pointerEvents:isButtonLock?'none':'auto'}}>
                <p className="flex-item fs-14 color-white">Book</p>
              </div>
            </div>
          </div>
        )
      }
    </div>
  )
}

export default MemberSlotBooking;